<script>
import Layout from '@layouts/main'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
    }
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then(token => {
          this.tryingToLogIn = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'dashboard' })
        })
        .catch(error => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>

<template>
  <Layout>
    <img
      :class="$style.loginLogo"
      src="../../assets/images/power-logo.png"
      alt="power waste logo"
    >
    <form
      :class="$style.form"
      @submit.prevent="tryToLogIn"
    >
      <BaseInput
        v-model="username"
        name="username"
        placeholder="Username"
      />
      <BaseInput
        v-model="password"
        name="password"
        type="password"
        placeholder="Password"
      />
      <BaseButton
        :disabled="tryingToLogIn"
        type="submit"
        :class="$style.loginButton"
      >
        <BaseIcon
          v-if="tryingToLogIn"
          name="sync"
          spin
        />
        <span v-else>
          Log in
        </span>
      </BaseButton>
      <a 
        class="customLink" 
        href="/admin/forget"
      >
        Forget Password?
      </a>
      <p
        v-if="authError"
        :class="$style.alertColor"
      >
        There was an error logging into your account.
      </p>
    </form>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.loginLogo {
  display: block;
  width: 20%;
  max-width: 200px;
  margin: 0 auto;
  margin-top: calc(55vh - 300px);
}

.loginButton{
  padding: 0.9em;
  margin-bottom: 1.3rem;
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px;
}

input {
  font-family: 'Poppins', sans-serif !important;
}

.alertColor{
  margin-top: 1.3rem;
  color: $red;
}

.form {
  max-width: 600px;
  padding: 60px 70px 60px 70px;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
  background-color: $white;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 10px 4px $shadow-black;
  -moz-box-shadow: 0 0 10px 4px $shadow-black;
  box-shadow: 0 0 10px 4px $shadow-black;
}
</style>
